var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6796 13.9802L15.4696 10.7702L13.5096 8.80023C12.6796 7.97023 11.3296 7.97023 10.4996 8.80023L5.31958 13.9802C4.63958 14.6602 5.12958 15.8202 6.07958 15.8202H11.6896H17.9196C18.8796 15.8202 19.3596 14.6602 18.6796 13.9802Z",
    fill: "#2C62CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpActive);
export default __webpack_public_path__ + "static/media/arrowUpActive.e790616b44b78e4b0a4d98cb42f93c70.svg";
export { ForwardRef as ReactComponent };